export default __webpack_public_path__ + "static/media/protein gallery desktop.6f7ecff2.jpg";